import React from 'react';
import {req_feedback_title, req_feedback_title_status} from '../../../../Helper/Constants';
import ManagedListSection from './ManagedListSection';

export default function FeedbackTitleSection(props) {
    const {language} = props;
    return (
        <ManagedListSection
            {...props}
            endpoint={req_feedback_title}
            statusEndpoint={req_feedback_title_status}
            idField="id"
            nameField="title"
            statusField="status"
            dialogTitle={language.feedback_add_title}
            fieldLabel={language.feedback_title}
            validationMessage={language.name_required}
        />
    );
}
